import React from "react";
import Iframe from "components/iframe";

const CoversBookGuide = ({ data: { url, title } }) => (
    <Iframe url={url} title={title || "Video"} className="w-full h-[28.85rem] md:h-[16.875rem]" />
);

export default CoversBookGuide;
